module.exports = __webpack_public_path__ + "img/home.1975f92d.svg";